<template>
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10 6.62829C10 6.00425 9.20436 5.31413 8 5.31413M8 5.31413C6.79564 5.31413 6.00015 5.88075 6 6.62829C5.99985 7.37583 6.93298 7.73917 8.06139 7.9587C9.24534 8.18904 10 8.56699 10 9.25692C10 9.98765 9.22476 10.5002 8 10.5002M8 5.31413V3.77775M8 10.5002C6.77524 10.5002 6 9.96316 6 9.25692M8 10.5002V12.2599M14 8C14 11.3137 11.3137 14 8 14C4.68629 14 2 11.3137 2 8C2 4.68629 4.68629 2 8 2C11.3137 2 14 4.68629 14 8Z"
      stroke="var(--icon-border-default)"
      stroke-width="1.1"
    />
  </svg>
</template>
